/* XR - banner editorial dentro de la cuadricula de coleccion */
(function () {
  function place() {
    var tpls = document.querySelectorAll('template[data-xr-grid-banner]');
    if (!tpls.length) return;
    var grid = document.querySelector('#ResultsList ul.product-grid');
    if (!grid || grid.querySelector('.xr-grid-insert')) return;
    var page = new URLSearchParams(location.search).get('page');
    if (page && page !== '1') return;
    var items = grid.querySelectorAll(':scope > li:not(.xr-grid-insert)');
    var t = tpls[0];
    var n = parseInt(t.dataset.after, 10) || 8;
    if (items.length < n + 1) return;
    items[n - 1].after(t.content.cloneNode(true));
  }
  function init() {
    place();
    var r = document.getElementById('ResultsList');
    if (r && !r.dataset.xrObs) {
      r.dataset.xrObs = '1';
      new MutationObserver(function () { place(); }).observe(r, { childList: true, subtree: true });
    }
    var wrap = document.querySelector('.main-collection, [data-template] main, main');
    if (wrap && !document.documentElement.dataset.xrMain) {
      document.documentElement.dataset.xrMain = '1';
      new MutationObserver(function () { var rr = document.getElementById('ResultsList'); if (rr && !rr.dataset.xrObs) init(); }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
